// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".separator{border-top:1px solid #c6ced5;margin-bottom:8px;margin-top:8px}.separator-big{border-top:1px solid #c6ced5;margin-bottom:24px;margin-top:32px}\n", ""]);
// Exports
module.exports = exports;
